<script setup lang="ts">
import zhCn from "element-plus/es/locale/lang/zh-cn"
</script>

<template>
  <el-config-provider :locale="zhCn">
    <router-view />
  </el-config-provider>
</template>

<style lang="scss">
@import '@/styles/animate/animate.min.css';
@import url("@/assets/fonts/index.css");
</style>
